import { render, staticRenderFns } from "./UdefMediaCard.vue?vue&type=template&id=3ede70a5&scoped=true&"
import script from "./UdefMediaCard.vue?vue&type=script&lang=js&"
export * from "./UdefMediaCard.vue?vue&type=script&lang=js&"
import style0 from "./UdefMediaCard.vue?vue&type=style&index=0&id=3ede70a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ede70a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
